export default __webpack_public_path__ + "static/media/Pleasewait.4f2c6639.gif";